module.exports = __webpack_public_path__ + "static/media/fine.2e40bdfe.jpg";